module.exports = __webpack_public_path__ + "fonts/jioicons--909f1eebaca13ed6ff3ca5134372a6be.909f1eebaca13ed6ff3ca5134372a6be.ttf";